import { Component, OnInit } from "@angular/core";
import { CloudStorageService } from "../../../services/cloud-storage";
import { SiteParameterService } from "../../../services/siteparameter.service";

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
})
export class DashboardComponent implements OnInit {

  constructor(public cloudStorageService: CloudStorageService, private siteParmService: SiteParameterService) { }

  ngOnInit(): void {

  }
}
